import Mock from 'mockjs';

import './message-box';

import '@/views/dashboard/workplace/mock';

import '@/views/dashboard/monitor/mock';

import '@/views/follow-up/list/mock';

import '@/views/customer/mock';

Mock.setup({
  timeout: '600-1000',
});
